import { render, staticRenderFns } from "./quiz.vue?vue&type=template&id=770fddd5&scoped=true"
import script from "./quiz.vue?vue&type=script&lang=ts"
export * from "./quiz.vue?vue&type=script&lang=ts"
import style0 from "./quiz.vue?vue&type=style&index=0&id=770fddd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770fddd5",
  null
  
)

export default component.exports